import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceInfoComponent } from './device-info.component';
import { ParsedDateTimeModule } from 'src/app/libs/ui/pipes/parsed-date-time/parsed-date-time.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DeviceInfoComponent],
  imports: [CommonModule, ParsedDateTimeModule, TranslateModule],
  exports: [DeviceInfoComponent],
})
export class DeviceInfoModule {}
